var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_997_616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 5.74089H11.3346V4.40755C11.3346 2.56755 9.8413 1.07422 8.0013 1.07422C6.1613 1.07422 4.66797 2.56755 4.66797 4.40755V5.74089H4.0013C3.26797 5.74089 2.66797 6.34089 2.66797 7.07422V13.7409C2.66797 14.4742 3.26797 15.0742 4.0013 15.0742H12.0013C12.7346 15.0742 13.3346 14.4742 13.3346 13.7409V7.07422C13.3346 6.34089 12.7346 5.74089 12.0013 5.74089ZM8.0013 11.7409C7.26797 11.7409 6.66797 11.1409 6.66797 10.4076C6.66797 9.67422 7.26797 9.07422 8.0013 9.07422C8.73464 9.07422 9.33464 9.67422 9.33464 10.4076C9.33464 11.1409 8.73464 11.7409 8.0013 11.7409ZM10.068 5.74089H5.93464V4.40755C5.93464 3.26755 6.8613 2.34089 8.0013 2.34089C9.1413 2.34089 10.068 3.26755 10.068 4.40755V5.74089Z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_997_616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.407227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9eb8e205806cff408924952068b1151e.svg";
export { ForwardRef as ReactComponent };